import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { LeadCaptureForm } from './LeadCaptureForm';
import { PhoneMockup } from './PhoneMockup';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -30
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function WebinarHero() {
  return <section style={{
    position: 'relative',
    overflow: 'hidden',
    paddingTop: '48px',
    paddingBottom: '48px',
    minHeight: '100vh'
  }} data-id="element-134">
      {/* Full-section background image */}
      <motion.img src="https://cdn.magicpatterns.com/uploads/8taVGp7BRW2mv6sUvkVscQ/Webinar_jose.png" alt="" aria-hidden="true" initial={{
      opacity: 0,
      scale: 1.05
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.2,
      ease: 'easeOut'
    }} style={{
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center top',
      display: 'block',
      zIndex: 0
    }} data-id="element-135" />

      {/* Multi-layer overlay: left side stays dark, right side fades to near-black for form */}
      <div style={{
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(105deg, rgba(10,10,15,0.97) 0%, rgba(10,10,15,0.88) 38%, rgba(10,10,15,0.55) 60%, rgba(10,10,15,0.3) 100%)',
      zIndex: 1,
      pointerEvents: 'none'
    }} data-id="element-136" />
      {/* Bottom fade for form readability */}
      <div style={{
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(to bottom, transparent 0%, transparent 50%, rgba(10,10,15,0.7) 80%, rgba(10,10,15,0.95) 100%)',
      zIndex: 1,
      pointerEvents: 'none'
    }} data-id="element-137" />

      {/* Grid pattern overlay */}
      <div className="grid-pattern" style={{
      position: 'absolute',
      inset: 0,
      opacity: 0.3,
      pointerEvents: 'none',
      zIndex: 1
    }} data-id="element-138" />

      {/* Ambient glow blobs */}
      <div style={{
      position: 'absolute',
      top: '10%',
      left: '5%',
      width: '400px',
      height: '400px',
      background: 'radial-gradient(circle, rgba(24,163,159,0.1) 0%, transparent 70%)',
      pointerEvents: 'none',
      zIndex: 1
    }} data-id="element-139" />
      <div style={{
      position: 'absolute',
      bottom: '10%',
      right: '10%',
      width: '300px',
      height: '300px',
      background: 'radial-gradient(circle, rgba(242,42,114,0.08) 0%, transparent 70%)',
      pointerEvents: 'none',
      zIndex: 1
    }} data-id="element-140" />

      <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 16px',
      position: 'relative',
      zIndex: 2
    }} data-id="element-141">
        <div style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        gap: '32px',
        alignItems: 'center'
      }} className="hero-grid" data-id="element-142">
          {/* LEFT SIDE */}
          <motion.div variants={containerVariants} initial="hidden" animate="visible" style={{
          maxWidth: '640px'
        }} data-id="element-143">
            {/* Badge */}
            <motion.div variants={itemVariants} style={{
            marginBottom: '20px'
          }} data-id="element-144">
              <span style={{
              display: 'inline-block',
              border: '1px solid var(--color-teal)',
              color: 'var(--color-teal)',
              fontSize: '11px',
              fontWeight: 700,
              fontFamily: 'Poppins, sans-serif',
              letterSpacing: '0.12em',
              padding: '6px 14px',
              borderRadius: '100px',
              background: 'rgba(24,163,159,0.07)'
            }} data-id="element-145">
                🎯 MASTERCLASS GRATUITO EN VIVO
              </span>
            </motion.div>

            {/* Headline */}
            <motion.h1 variants={itemVariants} style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 900,
            lineHeight: 1.1,
            marginBottom: '20px',
            letterSpacing: '-0.02em'
          }} data-id="element-146">
              <span style={{
              display: 'block',
              fontSize: 'clamp(28px, 4vw, 52px)',
              color: 'white'
            }} data-id="element-147">
                Masterclass Gratis: Cómo Convertirte en
              </span>
              <span className="text-gradient-cyan-magenta" style={{
              display: 'block',
              fontSize: 'clamp(32px, 5vw, 60px)',
              lineHeight: 1.05,
              filter: 'drop-shadow(0 0 20px rgba(255,226,34,0.35))'
            }} data-id="element-148">
                Afiliado Pro de TikTok Shop
              </span>
              <span style={{
              display: 'block',
              fontSize: 'clamp(24px, 3.5vw, 46px)',
              color: 'white',
              opacity: 0.9
            }} data-id="element-149">
                y Monetizar tu Contenido desde Cero.
              </span>
            </motion.h1>

            {/* Sub-headline */}
            <motion.p variants={itemVariants} style={{
            color: '#a0a0b0',
            fontSize: 'clamp(15px, 1.8vw, 18px)',
            fontFamily: 'Inter, sans-serif',
            lineHeight: 1.7,
            marginBottom: '28px',
            maxWidth: '540px'
          }} data-id="element-150">
              Descubre el sistema paso a paso para promocionar productos de
              terceros, generar{' '}
              <strong style={{
              color: 'white'
            }} data-id="element-151">
                comisiones diarias
              </strong>{' '}
              y escalar tu cuenta de forma orgánica{' '}
              <strong style={{
              color: 'white'
            }} data-id="element-152">
                sin invertir en inventario ni publicidad.
              </strong>
            </motion.p>

            {/* Bullet points */}
            <motion.div variants={itemVariants} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            marginBottom: '32px'
          }} data-id="element-153">
              {['El algoritmo de TikTok Shop: cómo dominar la visibilidad orgánica', 'Selección de productos ganadores con criterios de demanda real', 'Estrategia de contenido que convierte audiencia en clientes'].map(point => <div key={point} style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '10px'
            }} data-id="element-154">
                  <div style={{
                width: '22px',
                height: '22px',
                borderRadius: '50%',
                background: 'rgba(24,163,159,0.15)',
                border: '1px solid rgba(24,163,159,0.45)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px'
              }} data-id="element-155">
                    <CheckIcon size={12} color="var(--color-teal)" data-id="element-156" />
                  </div>
                  <span style={{
                color: '#d0d0e0',
                fontSize: '15px',
                fontFamily: 'Inter, sans-serif',
                lineHeight: 1.5
              }} data-id="element-157">
                    {point}
                  </span>
                </div>)}
            </motion.div>

            {/* Host info */}
            <motion.div variants={itemVariants} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '14px 18px',
            background: 'rgba(255,255,255,0.06)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(24,163,159,0.2)',
            borderRadius: '14px',
            marginBottom: '16px',
            width: 'fit-content'
          }} data-id="element-158">
              <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #18a39f, #0d7a77)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 900,
              fontSize: '16px',
              color: 'white',
              flexShrink: 0,
              position: 'relative'
            }} data-id="element-159">
                JZ
                <div style={{
                position: 'absolute',
                bottom: '-2px',
                right: '-2px',
                background: '#ffe222',
                borderRadius: '4px',
                padding: '1px 4px',
                fontSize: '7px',
                fontWeight: 700,
                color: '#0a0a0f',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-160">
                  EXPERT
                </div>
              </div>
              <div data-id="element-161">
                <div style={{
                color: 'white',
                fontWeight: 700,
                fontSize: '15px',
                fontFamily: 'Poppins, sans-serif'
              }} data-id="element-162">
                  José Zabala
                </div>
                <div style={{
                color: '#a0a0b0',
                fontSize: '12px',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-163">
                  Fundador de Ventas 6452 • 7 años en eCommerce Digital
                </div>
              </div>
            </motion.div>

            {/* Social proof */}
            <motion.div variants={itemVariants} data-id="element-164">
              <span style={{
              color: 'var(--color-yellow)',
              fontSize: '14px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600
            }} data-id="element-165">
                ⭐⭐⭐⭐⭐ Más de <strong data-id="element-166">2,400 estudiantes</strong> ya aplican
                este sistema
              </span>
            </motion.div>
          </motion.div>

          {/* RIGHT SIDE: Glassmorphism form card */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut',
          delay: 0.3
        }} style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }} data-id="element-167">
            <div style={{
            width: '100%',
            maxWidth: '460px',
            background: 'rgba(10,10,15,0.75)',
            backdropFilter: 'blur(32px)',
            WebkitBackdropFilter: 'blur(32px)',
            border: '1px solid rgba(24,163,159,0.25)',
            borderRadius: '24px',
            boxShadow: '0 0 60px rgba(24,163,159,0.12), 0 0 120px rgba(242,42,114,0.06)',
            padding: '8px'
          }} data-id="element-168">
              <LeadCaptureForm data-id="element-169" />
            </div>
          </motion.div>
        </div>
      </div>

      <style data-id="element-170">{`
        @media (min-width: 900px) {
          .hero-grid {
            grid-template-columns: 3fr 2fr !important;
          }
        }
        @media (max-width: 640px) {
          section {
            padding-top: 32px !important;
            padding-bottom: 40px !important;
          }
        }
      `}</style>
    </section>;
}